import { Routes } from '@angular/router';
import { loginGuard } from '@kimbocare/auth';
import { guestGuard } from './core/guard/guest.guard';
import {
  isRootDomainGuard,
  isTenantDomainGuard,
} from './core/guard/domain.guards';

export const routes: Routes = [
  {
    path: '',
    canMatch: [isTenantDomainGuard],
    loadChildren: () =>
      import('./tenant/tenant.module').then((m) => m.TenantModule),
    canActivate: [loginGuard()],
  },
  {
    path: '',
    canMatch: [isRootDomainGuard],
    loadChildren: () =>
      import('./features/features.module').then((m) => m.FeaturesModule),
    canActivate: [loginGuard()],
  },
  {
    path: 'loginsuccess',
    loadChildren: () =>
      import('./tenant/login-transfer/login-transfer.module').then(
        (m) => m.LoginTransferModule,
      ),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (m) => m.AuthenticationModule,
      ),
    canActivate: [guestGuard()],
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./features/error/error.module').then((m) => m.ErrorModule),
  },
  {
    path: '**',
    redirectTo: 'error/error404',
    pathMatch: 'full',
  },
];
